/*
===========================================================

  Studio Automation Interface

  Main Entry File

===========================================================
*/

/*
-----------------------------------------------------------
  Import Modules
-----------------------------------------------------------
*/

// Vue
import Vue from 'vue'
import App from './App'

// NPM
import _ from 'lodash';
import io from 'socket.io-client';
import moment from 'moment-timezone';
import axios from 'axios';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

/*
-----------------------------------------------------------
  Components
-----------------------------------------------------------
*/

// Tooltips
Vue.directive('tooltip', VTooltip)

// Popover
Vue.component('v-popover', VPopover)
Vue.directive('close-popover', VClosePopover)

/*
-----------------------------------------------------------
  Global Shortcuts
-----------------------------------------------------------
*/

Vue.prototype.$moment = moment;
Vue.prototype.$socketIO = io;
Vue.prototype.$v = _.get;

Vue.prototype.$a2C = (string) => {
  
  if(!string){
    return string
  }

  const formatted = string
    .replace('Ambiance iQ', 'Creek')
    .replace('ambiance', 'creek')
    .replace('Ambiance', 'Creek')
    .replace('Ambiator', 'Creek')
    .replace('ambiator', 'Creek')
    .replace('ambiated', 'Creek')
    .replace('Ambiated', 'Creek')
    .replace('Silence At Creek Radio', 'Creek')

  return formatted

}

Vue.prototype.$time = { 
  
  format (time, type) {
  
    const formats = {
      'verbose': "YYYY-MM-DD H:mm:ss A",
      'time-only': "H:mm:ss A",
    }

    const formatted = moment(time).format(formats[type])

    return formatted

  }

}

/*
-----------------------------------------------------------
  Instantiate Vue
-----------------------------------------------------------
*/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  // router,
  render: h => h(App)
})
